import React from 'react'
// Escaped literal phrase; React text nodes prevent markup injection.
export default function SearchHighlight({ text = '', query = '' }) {
  const phrase = query.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+')
  return <>{phrase ? String(text).split(new RegExp(`(${phrase})`, 'ig')).map((part, index) => index % 2 ? <strong key={index}>{part}</strong> : part) : text}</>
}
